import Vue from 'vue';
import AppLayout from '@/Layouts/AppLayout';

Vue.component('app-layout', AppLayout);
